exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:480px){.main_white[data-v-53135f84]{background:#efede9}.results_open .row[data-v-53135f84]{padding-top:7px}}", ""]);

// exports
